import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var getAlphabet = function getAlphabet() {
  return _toConsumableArray(Array(26)).map(function (_, w) {
    return String.fromCharCode(w + 97);
  });
};